import {HttpHeaders} from '@angular/common/http';

// DOCS: Array urls for csv required
export const PATH_SERVICES_CSV: string[] = ['tpPedido/DescargarReporte'];

export const getHeadersPost = (token: string) => {
  return new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Authorization', `Bearer ${token}`);
};

export const getHeadersGet = (token: string) => {
  return new HttpHeaders().set('Authorization', `Bearer ${token}`);
};
